import { render, staticRenderFns } from "./repertPassward.vue?vue&type=template&id=4c21922e"
import script from "./repertPassward.vue?vue&type=script&lang=js"
export * from "./repertPassward.vue?vue&type=script&lang=js"
import style0 from "./repertPassward.vue?vue&type=style&index=0&id=4c21922e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports